import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgElectronischeSleutel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M32 12H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m22.337 25.06-3.592-3.592a3.657 3.657 0 0 1-4.16-5.884 3.655 3.655 0 0 1 5.883 4.16l5.315 5.316-2.584 2.585-1.723-1.723z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M9.5 30.498V26h-1v4.503a2.01 2.01 0 0 0 2.01 1.997H21v-1H10.51a1.01 1.01 0 0 1-1.01-1.002"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M32 15.5h-6v-1h6zM32 18.5h-4v-1h4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgElectronischeSleutel);

export default ForwardRef;
